import React from 'react'
import {
    HiOutlineGlobeAlt,
    HiOutlineViewList,
    HiOutlineBadgeCheck,
    HiOutlineBeaker,
    HiOutlineQuestionMarkCircle,
    HiOutlineNewspaper,
    HiOutlineSortAscending,
} from 'react-icons/hi'
import PokeballDarkLight from '../components/template/PokeballDarkLight'
import PokemonIcon from '../components/template/PokemonIcon'

const navigationIcon = {
    globe: <HiOutlineGlobeAlt />,
    teams: <HiOutlineViewList />,
    topteams: <HiOutlineSortAscending />,
    official: <HiOutlineBadgeCheck />,
    unofficial: <HiOutlineBeaker />,
    faq: <HiOutlineQuestionMarkCircle />,
    info: <HiOutlineNewspaper />,
    pokeball: <PokeballDarkLight />,
}

const getNavigationIcon = (id) => {
    return navigationIcon[id] || <PokemonIcon id={id} />;
}

export default getNavigationIcon
